import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiURL } from "../config/config";

const RequestPasswordReset = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ ปิด dark mode เสมอในหน้า public
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${apiURL}auth/request-reset`, {
        username: email,
      });
      toast.success(
        res.data.message || "Password reset link has been sent to your email."
      );
      setEmail("");
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Failed to send reset link. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F5E6FF] via-[#ECEBFF] to-[#DCD6FF] relative overflow-hidden">
      {/* 🌈 Soft neon glow background */}
      <div className="absolute inset-0 flex justify-center items-center">
        <div className="w-[420px] h-[420px] bg-fuchsia-400/30 rounded-full blur-3xl animate-pulse" />
      </div>

      {/* 🪞 Glassmorphism card */}
      <div className="relative backdrop-blur-2xl bg-white/70 border border-white/40 rounded-3xl shadow-lg w-full max-w-md p-8 sm:p-10 transition-all duration-300">
        {/* ✅ Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/Neonworks-logo.png"
            alt="Neonworks Logo"
            className="w-24 h-24 object-contain drop-shadow-md"
          />
        </div>

        {/* ✅ Header */}
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">
          Forgot Password?
        </h1>
        <p className="text-center text-sm text-gray-600 mb-6">
          Enter your registered email and we’ll send you a reset link.
        </p>

        {/* ✅ Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@neonworks.co.th"
              className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-fuchsia-500 focus:border-fuchsia-500 bg-white/60 text-gray-800 placeholder-gray-400 transition"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 rounded-xl font-semibold text-white bg-gradient-to-r from-fuchsia-500 to-indigo-500 hover:opacity-90 transition-all duration-300 shadow-md hover:shadow-lg ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        {/* ✅ Footer */}
        <div className="mt-4 text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-sm text-fuchsia-500 hover:text-fuchsia-600 transition focus:outline-none"
          >
            ← Back to Login
          </button>
        </div>

        <p className="text-[11px] text-center text-gray-400 mt-6">
          © {new Date().getFullYear()} Neonworks • All rights reserved
        </p>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
